export const API_BASE_URL = 'https://graphdata.khuranaandkhurana.com/'
// export const API_BASE_URL = 'http://127.0.0.1:8000/'
export const SEARCH_URL = API_BASE_URL + 'patents/'
export const PATENT_DETAILS_URL = API_BASE_URL + 'patents/details/'
export const APPLICATION_STATUS_URL = API_BASE_URL + 'patents/application-status/'
export const DOWNLOAD_DOCUMENT_URL = API_BASE_URL + 'patents/download-document/'
